import {QueryClient} from '@tanstack/react-query';

/**
 * Queries may retry once (a read is safe to repeat, and api() refuses it before fetch while the actor-changed
 * guard is tripped). Mutations NEVER retry: a repeated POST after an ACTOR_MISMATCH, a lost response or a
 * network error could save a document twice or under another user. retry:0 is TanStack's mutation default;
 * it is stated explicitly so a later default change cannot turn retries on.
 */
export const queryClientOptions={
 defaultOptions:{
  queries:{retry:1,staleTime:15000,refetchOnWindowFocus:false},
  mutations:{retry:0},
 },
} as const;

export const createQueryClient=()=>new QueryClient(queryClientOptions);
